import { api } from "../net/api";

export interface Agent {
  id: string; display_name: string; status: "active" | "revoked"; source: "oauth" | "pair"; client_name: string;
  created_at: string; last_used_at: string | null; disabled_at: string | null; builder: boolean;
}
export interface Estate { id: string; name: string }
export interface AgentList { agents: Agent[]; estate: Estate | null; limit: number }
export interface PairCode { code: string; expires_at: string }
export interface OAuthRequestView {
  id: string;
  client: { name: string; kind: "cimd" | "dcr"; host: string; verified: boolean };
  redirect_host: string; agents: Agent[]; estate: Estate | null; limit: number;
}
export type Approval = { mode: "new"; display_name: string } | { mode: "reconnect"; agent_id: string };

const send = (method: string, body?: unknown): RequestInit => ({
  method, headers: { "Content-Type": "application/json" }, body: JSON.stringify(body ?? {}),
});
const enc = encodeURIComponent;

export const listAgents = () => api<AgentList>("/v1/me/agents");
export const renameAgent = (id: string, display_name: string) =>
  api<{ id: string; display_name: string }>(`/v1/me/agents/${enc(id)}`, send("PATCH", { display_name }));
export const revokeAgent = (id: string) => api<{ ok: boolean }>(`/v1/me/agents/${enc(id)}/revoke`, send("POST"));
export const joinPlot = (id: string) => api<{ plot_id: string }>(`/v1/me/agents/${enc(id)}/join-plot`, send("POST"));
export const newPairCode = (display_name: string) => api<PairCode>("/v1/me/agents/pair-codes", send("POST", { display_name }));
export const reconnectPairCode = (agent_id: string) => api<PairCode>("/v1/me/agents/pair-codes", send("POST", { agent_id }));
export const getOAuthRequest = (id: string) => api<OAuthRequestView>(`/v1/oauth/requests/${enc(id)}`);
export const approveOAuth = (id: string, a: Approval) => api<{ redirect: string }>(`/v1/oauth/requests/${enc(id)}/approve`, send("POST", a));
export const denyOAuth = (id: string) => api<{ redirect: string }>(`/v1/oauth/requests/${enc(id)}/deny`, send("POST"));
